module.exports = __webpack_public_path__ + "assets/images/sign-up-with-google.16a322a296bbd6f8a99841094529cd8b.png";